export enum AuroraResource {
  DataAggregator = "accumulators",
  Configuration = "configurations",
  Event = "events",
  Node = "nodes",
}

export enum KraftvaktResource {
  // outage-api
  Contact = "contact",
  MessageTemplate = "message-template",
  Outage = "outage",
  OutageType = "outage-types",
  Place = "place",
  Shift = "shift",
  Subscriber = "subscriber",
  SubscriberType = "subscriber-types",
}

export enum MeterControlResource {
  FlowInstance = "flow-instances",
  Flow = "flows",
  FlowStep = "flow-steps",
  Action = "actions",
  IntegrationType = "integration-types",
  Integration = "integrations",
  DisconnectFailureToPayFlowInstance = "disconnect-failure-to-pay-flows",
}

export enum AdministrationResource {
  // schedule-api
  Job = "job",
  // logging-api
  LoggingApiMessage = "logging-message",
  // outage-api
  // SubscriberType = KraftvaktResource.SubscriberType,
  // OutageType = KraftvaktResource.OutageType,
}
